
$('.js-close-ip-modal').click(() => {
    $('.ip-modal').fadeOut();
    return true;
});
